var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle, showCustomTitle: _vm.isEdittingLocked },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u(
      [
        {
          key: "titleLine",
          fn: function () {
            return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
          },
          proxy: true,
        },
        {
          key: "form",
          fn: function () {
            return [
              _c("ValidationObserver", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ invalid, dirty, handleSubmit }) {
                      return [
                        _c("ValidationProvider", {
                          attrs: {
                            rules: "required_field",
                            name: "Client name",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        errors: errors,
                                        name: "project_title",
                                        placeholder: "Enter title",
                                        disabled: _vm.isEdittingLocked,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [_vm._v(" Title* ")]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.project.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.project, "name", $$v)
                                        },
                                        expression: "project.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c(
                          "div",
                          { staticClass: "flex justify-between" },
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-6/12 mr-3",
                              attrs: {
                                id: "start_date",
                                rules: "required_field",
                                name: "Start Date",
                                vid: "start_date",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              errors: errors,
                                              name: "start_date",
                                              title: "Start Date*",
                                              id: "startDate",
                                            },
                                          },
                                          [
                                            _c("FormDatepicker", {
                                              attrs: {
                                                name: "start date",
                                                invalid: failed,
                                                disabled: _vm.isEdittingLocked,
                                              },
                                              model: {
                                                value: _vm.project.start_date,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.project,
                                                    "start_date",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "project.start_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("ValidationProvider", {
                              staticClass: "w-6/12",
                              attrs: {
                                rules:
                                  "noBeforeDate:@start_date,@ongoing|required_field",
                                name: "End Date",
                                vid: "end_date",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              errors: errors,
                                              title: "End Date*",
                                              id: "endDate",
                                              name: "end_date",
                                            },
                                          },
                                          [
                                            _c("FormDatepicker", {
                                              attrs: {
                                                name: "end_date",
                                                calendarClass:
                                                  "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                                                invalid: failed,
                                                disabled: _vm.isEdittingLocked,
                                              },
                                              model: {
                                                value: _vm.project.end_date,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.project,
                                                    "end_date",
                                                    $$v
                                                  )
                                                },
                                                expression: "project.end_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              title: "Country",
                              id: "countryId",
                              name: "countrySelect",
                            },
                          },
                          [
                            _c("ProfileCountrySelect", {
                              attrs: { disabled: _vm.isEdittingLocked },
                              model: {
                                value: _vm.project.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.project, "country", $$v)
                                },
                                expression: "project.country",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("RegionInput", {
                          attrs: {
                            id: "regionInput",
                            countries: _vm.project.country,
                            disabled: _vm.isEdittingLocked,
                          },
                          model: {
                            value: _vm.project.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.project, "state", $$v)
                            },
                            expression: "project.state",
                          },
                        }),
                        _c("ValidationProvider", {
                          attrs: { name: "City", rules: "name_with_spaces" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        title: "City",
                                        placeholder: "Enter city",
                                        disabled: _vm.isEdittingLocked,
                                        errors: errors,
                                      },
                                      model: {
                                        value: _vm.project.city,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.project,
                                            "city",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "project.city",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        !_vm.isManager
                          ? _c("ValidationProvider", {
                              attrs: { name: "Manager" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              errors: errors,
                                              title: "Manager",
                                              name: "manager",
                                            },
                                          },
                                          [
                                            _c("ManagersMultiselect", {
                                              attrs: {
                                                value: _vm.selectedManagersIds,
                                                invalid: failed,
                                                multiple: false,
                                                placeholder: "Select a manager",
                                                title: "Manager",
                                                disabled: _vm.isEdittingLocked,
                                              },
                                              on: {
                                                input: _vm.handleManagerInput,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        _c(
                          "FormGroup",
                          { attrs: { title: "Skills" } },
                          [
                            _c("CustomSkillsMultiselect", {
                              attrs: {
                                previouslyChosenSkillsIds: _vm.projectSkillsIds,
                                disabled: _vm.isEdittingLocked,
                              },
                              on: { skillsListUpdated: _vm.updateSkills },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ skill }) {
                                      return [
                                        _vm.isPersonalSkill(skill)
                                          ? _c("SkillMultiselectItem", {
                                              attrs: {
                                                labelText:
                                                  "Your personal skill",
                                                skillName: skill.name,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm.personalSkillsChosenWarning
                              ? _c("FormError", [
                                  _c("span", { staticClass: "font-bold" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.personalSkillsChosenWarning
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(
                                    " - will be available to everyone within the company "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "flex justify-between" },
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-6/12",
                              attrs: { name: "Min Budget", vid: "min_budget" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              errors: errors,
                                              disabled: _vm.isEdittingLocked,
                                              title: "Min Budget",
                                              id: "min_budget",
                                            },
                                          },
                                          [
                                            _c("FormInputGroup", {
                                              attrs: {
                                                disabled: _vm.isEdittingLocked,
                                                type: "number",
                                                placeholder: "min",
                                                inputClasses: "pl-7",
                                                prefix: "$",
                                              },
                                              model: {
                                                value: _vm.project.min_budget,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.project,
                                                    "min_budget",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "project.min_budget",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("p", { staticClass: "budgetHyphen" }, [
                              _vm._v("-"),
                            ]),
                            _c("ValidationProvider", {
                              staticClass: "w-6/12",
                              attrs: {
                                name: "Max Budget",
                                rules: "noBigger:@min_budget",
                                delay: "1000",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, failed }) {
                                      return [
                                        _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              errors: errors,
                                              title: "Max Budget",
                                              id: "max_budget",
                                            },
                                          },
                                          [
                                            _c("FormInputGroup", {
                                              attrs: {
                                                invalid: failed,
                                                disabled: _vm.isEdittingLocked,
                                                type: "number",
                                                placeholder: "max",
                                                inputClasses: "pl-7",
                                                prefix: "$",
                                              },
                                              model: {
                                                value: _vm.project.max_budget,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.project,
                                                    "max_budget",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "project.max_budget",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "FormGroup",
                          { attrs: { title: "Description" } },
                          [
                            _c("FormTextarea", {
                              attrs: {
                                rows: 10,
                                name: "description",
                                placeholder: "Describe the Client",
                                disabled: _vm.isEdittingLocked,
                              },
                              model: {
                                value: _vm.project.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.project, "description", $$v)
                                },
                                expression: "project.description",
                              },
                            }),
                          ],
                          1
                        ),
                        !_vm.data
                          ? _c(
                              "div",
                              { staticClass: "text-sm text-gray-800 p-2" },
                              [
                                _vm._v(
                                  " After creating this project you will be taken to your Project Page where you can add information such as managers, tasks, details, documents and contractors. "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("ModalSectionsDivider"),
                        _c(
                          "div",
                          { staticClass: "flex pt-5" },
                          [
                            _c("UIButton", {
                              staticClass: "mr-3",
                              attrs: {
                                variant: "outline",
                                id: "cancelProject",
                                buttonText: "Cancel",
                              },
                              on: { click: _vm.closeModal },
                            }),
                            _vm.data
                              ? _c("UIButton", {
                                  attrs: {
                                    disabled: invalid || _vm.isEdittingLocked,
                                    buttonText: _vm.buttonText,
                                    id: "createProjectButton",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.onSubmit)
                                    },
                                  },
                                })
                              : _c("UIButton", {
                                  attrs: {
                                    disabled: invalid || !dirty,
                                    buttonText: _vm.buttonText,
                                    id: "createNewProj",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.onSubmit)
                                    },
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }